import { roadMeasureResultsBodyTemplate } from "../../../../widgets/table/tableFeatures/tableTemplates/tableBodyTemplates/roadMeasureResults"
import { LineValuesColumnsPattern } from "../../../../widgets/table/tableFeatures/tableTemplates/tableHeaderColumnGroupTemplates/roadMeasureResults"

export function defineTableLineColumnsPattern(reverseLineCount: number, forwardLineCount: number) {
    const reverseLines = Array.from({ length: reverseLineCount }, (_, i) => `Reverse${8 - i}`).reverse()
    const forwardLines = Array.from({ length: forwardLineCount }, (_, i) => `Forward${i + 1}`)
    const columnsLines = {
        reverseLines,
        forwardLines
    }
    return columnsLines
}

export function defineTableSideColumnsPattern({ reverseLines, forwardLines }: LineValuesColumnsPattern) {
    const allLines = [...reverseLines, ...forwardLines]
    const sidesPattern = allLines.flatMap(line => [
        {
            headerName: 'Левая',
            field: `${line}Value`
        },
        {
            headerName: 'Правая',
            field: `${line}AdditionalValue`
        }
    ])
    return sidesPattern
}

export function defineRoadMeasureResultsTableLineColumnsStructure({ reverseLines, forwardLines }: LineValuesColumnsPattern) {
    const allLines = [
        ...reverseLines.map((line, i) => ({
            line,
            index: i + 1,
        })),
        ...forwardLines.map((line, i) => ({
            line,
            index: reverseLines.length + i + 1,
        })),
    ]

    return allLines.map(({ line, index }) => ({
        headerName: index,
        field: `${line}Value`,
        valueType: "float",
        align: "center",
        bodyTemplate: roadMeasureResultsBodyTemplate
    }))
}

export function defineRoadMeasureResultsTableSideColumnsStructure(sides: any[]) {
    return sides.map(({ headerName, field }: any) => ({
        headerName,
        field,
        valueType: "float",
        align: "center",
        bodyTemplate: roadMeasureResultsBodyTemplate
    }))
}